import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/why-are-we-different-dark.svg")